import { Icon } from "@rsuite/icons";
import React from "react";
import { ComponentProps } from "react";
import { MdContentCopy, MdLink } from "react-icons/md";
import { Input, InputGroup } from "rsuite";

type UrlInputGroupProps = ComponentProps<typeof Input>;

const UrlInputGroup = ({ value, ...props }: UrlInputGroupProps) => {
  const url = value?.toString() ?? '';

  return (
    <InputGroup inside>
      <InputGroup.Button
        onClick={() => url && window.open(url, '_blank')}
        disabled={!url}
      >
        <Icon as={MdLink} />
      </InputGroup.Button>

      <Input {...props} value={url} />

      <InputGroup.Button
        onClick={() => navigator.clipboard.writeText(url)}
        disabled={!url}
      >
        <Icon as={MdContentCopy} />
      </InputGroup.Button>
    </InputGroup>
  );
};

export default UrlInputGroup;